const apiVersion = 'v1';

const getThermostatLatestUsage = async (siteId: number) => {
  try {
    const response = await window.axios.get(
      `/${apiVersion}/Thermostats/latest-readings`,
      {
        params: { siteId },
      }
    );
    const { data } = response.data;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const deleteThermostat = async (thermostatId: number) => {
  try {
    await window.axios.delete(`/${apiVersion}/Thermostats/${thermostatId}`);
  } catch (err) {
    return Promise.reject(err);
  }
};

interface IThermostat {
  thermostatId: number;
}

interface IThermostatScheduleContractItem {
  planTypeId: number;
  planTypeName: string;
  schedule: string;
}

const getThermostatsBySite = async (siteId: number) => {
  try {
    const response = await window.axios.get(
      `/${apiVersion}/thermostats/sites/${siteId}`
    );
    const { data } = response.data;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const setThermostatData = async (thermostatData: IThermostat) => {
  try {
    const response = await window.axios.put(
      `/${apiVersion}/Thermostats/${thermostatData.thermostatId}/settings`,
      thermostatData
    );
    const { data } = response.data;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const GetThermostatSettingsMessages = async (thermostatId: number) => {
  try {
    const response = await window.axios.get(
      `/${apiVersion}/Thermostats/${thermostatId}/history`
    );
    const { data } = response.data;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const getThermostatScheduleSettings = async (thermostatId: number) => {
  try {
    const response = await window.axios.get(
      `/${apiVersion}/thermostats/${thermostatId}/schedule`
    );
    const { data } = response.data;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const updateThermostatScheduleSettings = async (
  thermostatId: number,
  payload: IThermostatScheduleContractItem[]
) => {
  try {
    const response = await window.axios.put(
      `/${apiVersion}/thermostats/${thermostatId}/schedule`,
      payload
    );
    const { data } = response.data;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

export default {
  getThermostatsBySite,
  getThermostatLatestUsage,
  deleteThermostat,
  setThermostatData,
  GetThermostatSettingsMessages,
  getThermostatScheduleSettings,
  updateThermostatScheduleSettings,
};
